import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useAutoLogout from "./context/useAutoLogout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import BoardMenu from "./pages/BoardMenu";
import Subscribe from "./pages/Subscribe";
import { Toaster } from "sonner";

import PrivateRoute from "./components/PrivateRoute";

function About() {
  return <h1 className="text-2xl">About Page</h1>;
}

function App() {
  useAutoLogout();
  return (
    <Router>
      <div className="">
        <Toaster richColors />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<About />} />
          <Route element={<PrivateRoute />}>
            <Route path="/board" element={<BoardMenu />} />
            <Route path="/souscrire" element={<Subscribe />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
